import { useEffect, useState } from "react";
import "dayjs/locale/ja";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/types";
import { useTranslation } from "react-i18next";
import useScreenSize from "../../../../hooks/useScreenSize";
import { DatePicker, Radio } from "antd";
import dayjs, { Dayjs } from "dayjs";
import { DateFormat } from "../../../../shared/constants";
import ProfileCompletion from "../../../../components/ProfileCompletion";
type DateRange = [Dayjs | null, Dayjs | null] | null;

const UserHome = () => {
  const { t } = useTranslation();
  const { loggedInUser } = useSelector((state: RootState) => state.global);
  const { isMobile } = useScreenSize();
  const [currentTime, setCurrentTime] = useState(
    new Intl.DateTimeFormat("en", { day: "numeric", month: "long", weekday: "long", year: "numeric" }).format(Date.now())
  );

  const [category, setCategory] = useState<string | null>("month");
  const [startDate, setStartDate] = useState<Dayjs | null>(dayjs().add(-12, "months"));
  const [endDate, setEndDate] = useState<Dayjs | null>(dayjs());

  const [monthRange, setMonthRange] = useState<DateRange>([dayjs().add(-12, "months"), dayjs()]);
  const [yearRange, setYearRange] = useState<DateRange>([dayjs().add(-5, "years"), dayjs()]);

  const { MonthPicker, YearPicker } = DatePicker;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(
        dayjs().format("dddd hh:mm A")
        // new Intl.DateTimeFormat(loggedInUser?.language || "ar", { day: "numeric", month: "long", weekday: "long", year: "numeric" }).format(Date.now())
      );
    }, 50 * 1000); // Update every 50 seconds

    return () => clearInterval(interval);
  }, []);

  const setParams = (paramName: "category" | "startDate" | "endDate", value: any) => {
    switch (paramName) {
      case "category":
        setCategory(value);
        if (value === "year") {
          const sd = yearRange?.[0] ? dayjs(yearRange[0].format("YYYY-01-01")) : null;
          const ed = yearRange?.[1] ? dayjs(yearRange[1].format("YYYY-12-31")) : null;
          setStartDate(sd);
          setEndDate(ed);
        } else {
          const sd = monthRange?.[0] ? dayjs(monthRange[0].format("YYYY-MM-01")) : null;
          const ed = monthRange?.[1] ? dayjs(monthRange[1].format(`YYYY-MM-${monthRange[1].daysInMonth()}`)) : null;
          setStartDate(sd);
          setEndDate(ed);
        }
        break;
      case "startDate":
        if (category === "year") {
          setYearRange([value, yearRange![1]]);
          const sd = value ? dayjs(value.format("YYYY-01-01")) : null;
          const ed = yearRange?.[1] ? dayjs(yearRange[1].format("YYYY-12-31")) : null;
          setStartDate(sd);
          setEndDate(ed);
        } else {
          setMonthRange([value, monthRange![1]]);
          const sd = value ? dayjs(value.format("YYYY-MM-01")) : null;
          const ed = monthRange?.[1] ? dayjs(monthRange[1].format(`YYYY-MM-${monthRange[1].daysInMonth()}`)) : null;
          setStartDate(sd);
          setEndDate(ed);
        }
        break;
      case "endDate":
        if (category === "year") {
          setYearRange([yearRange![0], value]);
          const sd = yearRange?.[0] ? dayjs(yearRange[0].format("YYYY-01-01")) : null;
          const ed = value ? dayjs(value.format("YYYY-12-31")) : null;
          setStartDate(sd);
          setEndDate(ed);
        } else {
          setMonthRange([monthRange![0], value]);
          const sd = monthRange?.[0] ? dayjs(monthRange[0].format("YYYY-MM-01")) : null;
          const ed = value ? dayjs(value.format(`YYYY-MM-${value.daysInMonth()}`)) : null;
          setStartDate(sd);
          setEndDate(ed);
        }
        break;
    }
  };

  return (
    <div className="w-[100%]">
      <div className="w-[100%] mb-1">
        <div className="font-large text-primary" style={{ textAlign: "center", width: "100%", fontWeight: "bolder" }}>{currentTime}</div>
      </div>
      <ProfileCompletion />
      <div className="w-[100%] mt-[5px] mb-[5px]">
        <Radio.Group defaultValue={category} size="middle" className={`${isMobile ? "w-full" : ""} ml-[5px] mr-[5px] float-left`} onChange={(val) => setParams("category", val.target.value)}>
          <Radio.Button className={isMobile ? "w-[50%]" : ""} value="month">{t("Month wise")}</Radio.Button>
          <Radio.Button className={isMobile ? "w-[50%]" : ""} value="year">{t("Year wise")}</Radio.Button>
        </Radio.Group>
        <div className={isMobile ? "ml-[5px] mt-[5px]" : ""} style={{ width: isMobile ? "100%" : "auto", float: "left", fontSize: isMobile ? "13px" : "14px" }}>
          {t("Time period")} : &nbsp;
          {category === "month" && <>
            <MonthPicker value={monthRange?.[0]} onChange={(val: any) => setParams("startDate", val)} allowClear={false} showNow={true} format={isMobile ? DateFormat.SHORT_MONTH : DateFormat.MONTH} className={`${isMobile ? "w-[110px]" : "w-[150px]"} mr-[5px]`} placeholder={t("Select start month")} />
            -
            <MonthPicker value={monthRange?.[1]} onChange={(val: any) => setParams("endDate", val)} allowClear={false} showNow={true} format={isMobile ? DateFormat.SHORT_MONTH : DateFormat.MONTH} className={`${isMobile ? "w-[110px]" : "w-[150px]"} ml-[5px]`} placeholder={t("Select end month")} />
          </>}
          {category === "year" && <>
            <YearPicker value={yearRange?.[0]} onChange={(val: any) => setParams("startDate", val)} allowClear={false} showNow={true} format={DateFormat.YEAR} className={`${isMobile ? "w-[110px]" : "w-[150px]"} mr-[5px]`} placeholder={t("Select start year")} />
            -
            <YearPicker value={yearRange?.[1]} onChange={(val: any) => setParams("endDate", val)} allowClear={false} showNow={true} format={DateFormat.YEAR} className={`${isMobile ? "w-[110px]" : "w-[150px]"} ml-[5px]`} placeholder={t("Select end year")} />
          </>}
        </div>
      </div>
    </div>
  );
};

export default UserHome;
